import { StringParam, useQueryParam, withDefault } from 'use-query-params';

const SideParam = withDefault(StringParam, '');
const SideParamOptions = { updateType: 'replaceIn', enableBatching: true };

const useSideQueryParam = () => useQueryParam('side', SideParam, SideParamOptions);

export default useSideQueryParam;
